import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createVNode as _createVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-da40cd20")

_pushScopeId("data-v-da40cd20")
const _hoisted_1 = { class: "bg-ff" }
const _hoisted_2 = { class: "flex flexC" }
const _hoisted_3 = { class: "flex" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_9 = { class: "dialog-footer" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "确 定", -1)
const _hoisted_11 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_checkbox = _resolveComponent("el-checkbox")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _withDirectives(_createVNode(_component_el_table, {
      data: _ctx.tableData,
      stripe: "",
      style: {"width":"100%"},
      class: "table",
      "header-cell-style": _ctx.headClass
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (item, index) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            align: "center",
            prop: item.prop,
            label: item.label,
            "min-width": item.width,
            key: index
          }, null, 8, ["prop", "label", "min-width"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["data", "header-cell-style"]), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      title: "设置表单",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.dialogVisible = $event)),
      width: '1000px',
      "before-close": _ctx.handleClose
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_9, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.workSetupSetUp
          }, {
            default: _withId(() => [
              _hoisted_10
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.dialogVisible = false))
          }, {
            default: _withId(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_el_form, {
            "label-position": "right",
            "label-width": "160px",
            model: _ctx.form,
            ref: "formRef"
          }, {
            default: _withId(() => [
              _createVNode("div", _hoisted_3, [
                _createVNode(_component_el_form_item, { label: "领料出库反审核" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      border: "",
                      modelValue: _ctx.form.deaudit,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.deaudit = $event)),
                      "true-label": "1",
                      "false-label": "1"
                    }, {
                      default: _withId(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_checkbox, {
                      border: "",
                      modelValue: _ctx.form.deaudit,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.deaudit = $event)),
                      "true-label": "0",
                      "false-label": "0"
                    }, {
                      default: _withId(() => [
                        _hoisted_5
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode("div", _hoisted_6, [
                _createVNode(_component_el_form_item, { label: "同车牌开多个单" }, {
                  default: _withId(() => [
                    _createVNode(_component_el_checkbox, {
                      border: "",
                      modelValue: _ctx.form.carordernum,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.carordernum = $event)),
                      "true-label": "1",
                      "false-label": "1"
                    }, {
                      default: _withId(() => [
                        _hoisted_7
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createVNode(_component_el_checkbox, {
                      border: "",
                      modelValue: _ctx.form.carordernum,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.carordernum = $event)),
                      "true-label": "0",
                      "false-label": "0"
                    }, {
                      default: _withId(() => [
                        _hoisted_8
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_el_form_item, {
                label: "车牌区域",
                prop: "province"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_select, {
                    style: {"width":"78px"},
                    class: "mar-r-10",
                    modelValue: _ctx.form.carcoderegion[0],
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.carcoderegion[0] = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.provinceList, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"]),
                  _createVNode(_component_el_select, {
                    style: {"width":"58px"},
                    modelValue: _ctx.form.carcoderegion[1],
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.form.carcoderegion[1] = $event)),
                    placeholder: "请选择"
                  }, {
                    default: _withId(() => [
                      (_openBlock(), _createBlock(_Fragment, null, _renderList('ABCDEFGHIJKLNMOPQRSTOVWXYZ', (item) => {
                        return _createVNode(_component_el_option, {
                          key: item,
                          label: item,
                          value: item
                        }, null, 8, ["label", "value"])
                      }), 64))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "before-close"])
  ]))
})